
export default {
  data() {
    return {
      items: [
        { title: 'Seja Parceiro Contador', to: '/parceiro-contador' },
        { title: 'Seja Uma Revenda', to: '/seja-uma-revenda' },
      ],
    }
  },
}
